import Model from 'flarum/common/Model';
export default class FriendshipEvent extends Model {
  action = (() => Model.attribute('action'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  otherUser = (() => Model.hasOne('otherUser'))();
  actor = (() => Model.hasOne('actor'))();
}
flarum.reg.add('forumaker-friendship', 'common/models/FriendshipEvent', FriendshipEvent);